import React, { Component } from 'react'
import { Affix, message } from "antd"
import { observer, inject } from "mobx-react"

@inject("recycleDetail") @observer
export default class DataHeader extends Component {

  componentDidMount() {
    let { recycleDetail } = this.props

    recycleDetail.loadFamilyInfo()
      .catch(
        err => {
          message.error(err.message)
        }
      )
  }

  render() {
    const {
      familyInfo: { name, createTime },
    } = this.props.recycleDetail

    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={0}
      >
        <div className="search-bar">
          <div className="left">
            <div>数据类型：Array PGT数据</div>
            <div>家系名称：{name}</div>
            <div>创建时间：{createTime}</div>
          </div>
        </div>
      </Affix>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/recycle_detail/containers/DataHeader.js